import React, { PropsWithChildren } from 'react'
import { createContext } from 'lib/createContext'
import { parseErrorMessage } from 'api'
import { useEditBillRateMutation } from 'queries/billRates/useEditBillRateMutation'

type EditBillRateFlowContextState = {
  state: {
    mutationState: {
      isPending: boolean
      isError: boolean
      errorMessage: string | undefined
    }
  }
  actions: {
    submit: ReturnType<typeof useEditBillRateMutation>['mutate']
    reset: ReturnType<typeof useEditBillRateMutation>['reset']
  }
}

const [Context, useEditBillRateFlowContextValue] =
  createContext<EditBillRateFlowContextState>({
    name: 'EditBillRateFlowContext',
  })

export const EditBillRateFlowProvider = ({ children }: PropsWithChildren) => {
  const { mutate, reset, isPending, isError, error } = useEditBillRateMutation()

  const value: EditBillRateFlowContextState = {
    state: {
      mutationState: {
        isPending,
        isError,
        errorMessage: parseErrorMessage(error),
      },
    },
    actions: {
      submit: mutate,
      reset,
    },
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useEditBillRateFlowContextValue }
